import { useEffect, useState } from 'react';
import { User } from 'services/auth/auth.types';
import { useGetUserProfileMutation, useUpdatePersonalCommentMutation, useUpdateStakeholdersCommentMutation } from 'services/user/user.endpoint';
import { useUpdateProjectInitialRequestCommentMutation } from 'services/person/person.endpoint';
import { useCreateStakeholderAsUserMutation } from 'services/person/stakeholder/stakeholder.endpoint';

export default function useMyFolderVM() {
    const [me, setMe] = useState<User | null>(null);
    const [isAddStakeholderOpen, setIsAddStakeholderOpen] = useState(false);

    const [getMe, { data: meResponse, isLoading: isMeLoading }] = useGetUserProfileMutation();
    const [updatePersonalComment] = useUpdatePersonalCommentMutation();
    const [updateStakeholdersComment] = useUpdateStakeholdersCommentMutation();
    const [updateProjectInitialRequestComment] = useUpdateProjectInitialRequestCommentMutation();
    const [createStakeholder] = useCreateStakeholderAsUserMutation();

    useEffect(() => {
        getMe(undefined);
    }, [getMe]);

    useEffect(() => {
        if (meResponse?.data) setMe(meResponse.data);
    }, [meResponse]);

    const refetchMe = async () => {
        const res = await getMe(undefined).unwrap();
        if (res?.data) setMe(res.data);
    };

    const handleSavePersonalComment = async (value: string) => {
        await updatePersonalComment({ personal_comment: value }).unwrap();
        await refetchMe();
    };

    const handleSaveStakeholdersComment = async (value: string) => {
        await updateStakeholdersComment({ stakeholders_comment: value }).unwrap();
        await refetchMe();
    };

    const handleSaveInitialRequestComment = async (value: string) => {
        const projectId = me?.projects?.[0]?.id;
        if (!projectId) return;
        await updateProjectInitialRequestComment({ projectId, user_initial_request_comment: value }).unwrap();
        await refetchMe();
    };

    const handleAddStakeholder = async (data: { firstname: string; lastname: string; email?: string; phone?: string; status?: string }) => {
        await createStakeholder(data).unwrap();
        setIsAddStakeholderOpen(false);
        await refetchMe();
    };

    return {
        me,
        isLoading: isMeLoading,
        isAddStakeholderOpen,
        setIsAddStakeholderOpen,
        handleSavePersonalComment,
        handleSaveStakeholdersComment,
        handleSaveInitialRequestComment,
        handleAddStakeholder
    };
}
